import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import { getUrl } from '@/config/api.routes';

const routingAlias = 'conversations.conversations';

function getSelectedReview(review, conversation, agent, reviewsList, agentsWhoContributed) {
  let selectedReview;
  // Assign selectedReview based on where it's been launched
  if (review) { // Modal got launched from conversation reviews list
    selectedReview = review;
  } else { // Modal got launched from conversation log
    selectedReview = reviewsList.find(r => r.conversation.id === conversation.id && r.agent_id === agent.profile.id);
  }
  // Align the conversation schema to the selected review schema
  if (!selectedReview) { // New review
    selectedReview = {
      conversation,
      primary_agent: conversation.primaryAgent,
      agents_who_contributed: agentsWhoContributed,
    };
  }
  return selectedReview;
}

export default {
  namespaced: true,

  state: {
    reviewsList: [],
    conversationIds: [],
    isListLoading: false,
    isDialogVisible: false,
    selectedReview: null,
  },

  mutations: {
    SET_REVIEWS_LIST(state, reviewsList) {
      state.reviewsList = reviewsList;
    },
    SET_CONVERSATION_IDS(state, conversationIds) {
      state.conversationIds = conversationIds;
    },
    SET_IS_LIST_LOADING(state, isListLoading) {
      state.isListLoading = isListLoading;
    },
    SET_IS_DIALOG_VISIBLE(state, isVisible) {
      state.isDialogVisible = isVisible;
    },
    CLEAR_DIALOG(state) {
      state.selectedReview = null;
    },
    SET_SELECTED_REVIEW(state, selectedReview) {
      state.selectedReview = selectedReview;
    },
  },

  actions: {
    async createReview({ state }, params) {
      const { rating, comment } = params;
      const conversationId = state.selectedReview.conversation.id;
      const response = await axios.post(`${getUrl(routingAlias)}/${conversationId}/reviews`, { rating, comment });
      return response.data;
    },
    async updateReview({ state }, params) {
      const { rating, comment } = params;
      const conversationId = state.selectedReview.conversation.id;
      const reviewId = state.selectedReview.id;
      const response = await axios.put(`${getUrl(routingAlias)}/${conversationId}/reviews/${reviewId}`, { rating, comment });
      return response.data;
    },
    async deleteReview({ state }) {
      const conversationId = state.selectedReview.conversation.id;
      const reviewId = state.selectedReview.id;
      const response = await axios.delete(`${getUrl(routingAlias)}/${conversationId}/reviews/${reviewId}`);
      return response.data;
    },
    async fetchReviews({ commit }, conversationIds) {
      commit('SET_IS_LIST_LOADING', true);
      const responses = await Promise.all(
        conversationIds.map(conversationId => axios.get(`${getUrl(routingAlias)}/${conversationId}/reviews`)),
      );
      const reviewsList = responses.reduce(
        (accumulator, response) => [...accumulator, ...response.data.models],
        [],
      );
      commit('SET_REVIEWS_LIST', reviewsList);
      commit('SET_CONVERSATION_IDS', conversationIds);
      commit('SET_IS_LIST_LOADING', false);
    },
    async refetchReviews({ dispatch, state }) {
      await dispatch('fetchReviews', state.conversationIds);
    },
    openDialog({ commit, state, rootState }, { review, conversation, agentsWhoContributed }) {
      const reviewsList = state.reviewsList;
      const selectedReview = getSelectedReview(
        cloneDeep(review),
        cloneDeep(conversation),
        rootState.agent,
        reviewsList,
        agentsWhoContributed,
      );
      commit('SET_SELECTED_REVIEW', selectedReview);
      commit('SET_IS_DIALOG_VISIBLE', true);
    },
    closeDialog({ commit }) {
      commit('SET_IS_DIALOG_VISIBLE', false);
      commit('SET_SELECTED_REVIEW', null);
    },
  },
};
